import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-wrapper">
      <div className="terms-container animate__animated animate__fadeInUp">
        <h1>Terms & Conditions</h1>
        <p className="last-updated">Last updated: July 25, 2025</p>

        <p>
          Welcome to SkillsHap. By using our platform, services, and any associated products, you agree to the following Terms and Conditions. Please read them carefully before using our services.
        </p>

        <section>
          <h2>1. Definitions</h2>
          <p>
           These Terms and Conditions (“Terms”) govern your access to and use of the SkillsHap CareerTech and HRTech platform (“SkillsHap”, “we”, “us”, or “our”). By using our services, including our website, mobile applications, AI tools, training modules, career consulting, or any affiliated offerings, you agree to comply with these Terms and acknowledge that you have read, understood, and accepted them fully. If you do not agree with any portion of these Terms, you must not access or use SkillsHap.  </p>
        </section>

        <section>
          <h2>2. Acceptance of Terms</h2>
          <p>
           By accessing or using SkillsHap, you enter into a binding agreement with us. Your continued use of the platform constitutes your agreement to abide by these Terms as well as any future amendments, our Privacy Policy, and any other policies or guidelines published by SkillsHap. You are solely responsible for regularly reviewing the Terms to stay informed of updates. Your access and participation in SkillsHap’s services are entirely voluntary and based on your acceptance of these conditions </p>
        </section>

        <section>
          <h2>3. Eligibility</h2>
          <p>
           SkillsHap services are intended for individuals who are at least sixteen (16) years of age or older. By using the platform, you affirm that you meet this age requirement and have the legal capacity to form a binding contract. If you are under the age of majority in your jurisdiction, your access to SkillsHap must be authorized and supervised by a parent or legal guardian who also agrees to these Terms. Unauthorized access by minors without supervision or consent may result in account termination. </p>
        </section>

        <section>
          <h2>4. Services Offered</h2>
          <p>
            SkillsHap provides:
            <ul>
              <li>Career mentorship (AI + Human hybrid model)</li>
              <li>Resume building & optimization</li>
              <li>Skill assessments & simulation-based learning</li>
              <li>Mock interviews by experts</li>
              <li>Job portal access and job tracking dashboard</li>
              <li>Partnership and affiliate programs (HR, Coaches, Sales Affiliates)</li>
            </ul>
            We may add, remove, or modify services at our sole discretion.
          </p>
        </section>

        <section>
          <h2>5. User Responsibilities</h2>
          <p>
            Users must:
            <ul>
              <li>Provide accurate and complete information during registration</li>
              <li>Use the platform ethically and legally</li>
              <li>Not share login credentials with others</li>
              <li>Not copy, distribute, or misuse platform content or proprietary materials</li>
            </ul>
          </p>
        </section>

        <section>
          <h2>6. Pricing and Payments</h2>
          <p>
            Some services may be free; others are paid. Payment terms will be clearly disclosed at the time of purchase. All fees are non-refundable, unless otherwise stated in writing.
          </p>
        </section>

        <section>
          <h2>7. Refund Policy</h2>
          <p>
            We do not provide refunds for any paid services, mentorship programs, resume support, or job portal access, except in exceptional cases where SkillsHap has failed to deliver the purchased service due to internal fault.
          </p>
        </section>

        <section>
          <h2>8. Intellectual Property</h2>
          <p>
            All content, tools, logos, and intellectual assets on the platform are owned by SkillsHap. No user may reuse, resell, or reproduce any material without prior written consent.
          </p>
        </section>

        <section>
          <h2>9. User-Generated Content</h2>
          <p>
            You may be allowed to post feedback, testimonials, or input. You grant SkillsHap a non-exclusive, royalty-free license to use such content for marketing or educational purposes.
          </p>
        </section>

        <section>
          <h2>10. Third-Party Links and Services</h2>
          <p>
            Our platform may link to third-party websites for jobs, assessments, or integrations. We are not responsible for their privacy practices, content, or terms.
          </p>
        </section>

        <section>
          <h2>11. Partnerships and Affiliates</h2>
          <p>
            Coaches, freelance HRs, and sales professionals joining our affiliate program must sign a separate MoU/NDA if required. Commissions are performance-based and subject to compliance with guidelines. Misuse, dishonesty, or spamming can result in termination without payout.
          </p>
        </section>

        <section>
          <h2>12. Use of the Platform</h2>
          <p>
            SkillsHap is built to offer users tools and content that enhance employability, training, career development, and placement opportunities. You agree to use the platform only for legitimate educational, professional, or developmental purposes. Misuse such as spamming, hacking, or sharing unlawful content is strictly prohibited and may lead to termination and legal action.
          </p>
        </section>

        <section>
          <h2>13. Use of AI and Placement Tools</h2>
          <p>
            SkillsHap uses AI to assist with career recommendations, resume feedback, job matching, and interview analysis. These suggestions are not guaranteed results and are meant for guidance only. Users should use their own judgment and consult human experts as needed.
          </p>
        </section>

        <section>
          <h2>14. Certificates and Recognition</h2>
          <p>
            Some SkillsHap programs provide certificates upon completion. These certify participation or learning but are not academic degrees or employment guarantees. They may be recognized by certain partners and are digitally verifiable where applicable.
          </p>
        </section>

        <section>
          <h2>15. Suspension and Termination</h2>
          <p>
            We reserve the right to suspend or terminate your access to SkillsHap at any time, with or without notice, if you violate these Terms or misuse our services. Access to services and certificates may be revoked, and SkillsHap is not liable for any resulting loss.
          </p>
        </section>

        <section>
          <h2>16. Testimonials and Content Submission</h2>
          <p>
            By submitting testimonials, reviews, or success stories, you grant SkillsHap the right to use and display this content in marketing, social media, or the platform itself. If you want to revoke this permission, please contact our support team.
          </p>
        </section>

        <section>
          <h2>17. Limitation of Liability</h2>
          <p>
            SkillsHap is not responsible for direct or indirect losses (e.g., job rejection or income loss) resulting from platform use. We offer tools and advice but cannot guarantee job outcomes or results.
          </p>
        </section>

        <section>
          <h2>18. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless SkillsHap, its employees, partners, and affiliates from any claims, damages, liabilities, or legal expenses arising out of your use of the platform or violation of these Terms.
          </p>
        </section>

        <section>
          <h2>19. Governing Law and Jurisdiction</h2>
          <p>
            These Terms shall be governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in <strong>Hyderabad, Telangana</strong>.
          </p>
        </section>

        <section>
          <h2>20. Changes to Terms</h2>
          <p>
            We may update these Terms at any time. Changes will be posted on the platform with the effective date. Continued use of the platform means you agree to the updated Terms.
          </p>
        </section>

        <section>
          <h2>21. Contact Information</h2>
          <p>
      For any questions or concerns, feel free to contact us:
    
      <li>📧 Email: <a href="mailto:support@skillshap.com">support@skillshap.com</a></li>
      <li>📍 Address: SkillsHap HQ, Novel MSR Park</li>
      <li>🏢 Corporate Office: Novel Office, 5th Floor, Marathahalli - 560037, Bengaluru, India</li>
      <li>🌐 Website: <a href="https://www.skillshap.com" target="_blank" rel="noopener noreferrer">www.skillshap.com</a></li>
       </p> </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
